const promptExamples = [
    {
        heading: 'Shorten a url',
        message: `https://en.wikipedia.org/wiki/Battle_of_Inverkeithing`
    },
    {
        heading: 'Top performing',
        message: 'What are my top performing links?'
    },
    {
        heading: 'Link safety',
        message: `Is it safe to visit this link https://bit.ly/next`
    },
    {
        heading: 'Suggest backhalfs',
        message: `Suggest some custom backhalfs for this url https://en.wikipedia.org/wiki/2023_FIFA_Women%27s_World_Cup`
    },
    {
        heading: 'Custom short link',
        message: `Shorten this link with my custom domain and additionally generate a custom bitlink with a custom backhalf of your choice https://en.wikipedia.org/wiki/Interstellar_(film)`
    },
    {
        heading: 'Generate QR code',
        message: `Generate a qr code for this url: https://palaceoffinearts.com/`
    },
    // {
    //     heading: 'Account info',
    //     message: `What can you tell me about my Bitly user account? Include my groups and organizations`
    // },
    {
        heading: 'Retrieve group bitlinks',
        message: `Show me the latest bitlinks in my group`
    },
    {
        heading: 'Fetch click metrics',
        message:
            'How many clicks did this link get in the last 2 months? https://bit.ly/bitly-card'
    },
    {
        heading: 'Expand a short link',
        message: `Where does this link redirect to https://bit.ly/next`
    },
    {
        heading: 'Multi-lingual',
        message: `yo link le kati outa clicks pako cha pachillo 2 mahina ma? https://bit.ly/bitly-card`
    },
    {
        heading: 'Tell me a dad joke',
        message: `Tell me a dad joke`
    }
];

export { promptExamples };
